import * as React from 'react';
import styled from 'styled-components';
import Text11 from '@sdk/components/ui/typography/Text11';
import Column from '@sdk/components/ui/spacing/Column';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';

import BottomSeparated from './BottomSeparated';

export const WrappedContent = styled(Column)`
  width: 338px;
`;

const TitleContainer = styled.div`
  margin-bottom: 10px;
`;

const CounterSeparator = styled(Text11)`
  margin-left: 2px;
  margin-right: 4px;
`;

export type SurveyStepProps = {
  number?: number;
  count?: number;
  title?: string;
  subtitle?: string;
};

const SurveyStep: React.FC<React.PropsWithChildren<SurveyStepProps>> = ({
  children,
  number,
  count,
  title,
  subtitle,
}) => {
  const showStepNumber = Number.isInteger(number);
  const showStepsCount = Number.isInteger(count);

  return (
    <WrappedContent>
      {showStepNumber && (
        <BottomSeparated>
          <Text11 themeColor={ThemeColorType.iconGray} semiBold>
            {number}
            {showStepsCount && (
              <>
                <CounterSeparator italic themeColor={ThemeColorType.iconGray}>
                  {gettext('of')}
                </CounterSeparator>
                {count}
              </>
            )}
          </Text11>
        </BottomSeparated>
      )}

      {!!title && (
        <TitleContainer>
          <Text14 themeColor={ThemeColorType.gray} semiBold>
            {title}
          </Text14>
        </TitleContainer>
      )}

      {!!subtitle && <Text14 themeColor={ThemeColorType.gray}>{subtitle}</Text14>}

      {children}
    </WrappedContent>
  );
};

export default SurveyStep;
